module.exports = __webpack_public_path__ + "static/media/14.0a5a118a.jpg";